import React, { Component } from 'react';
import './StatusView.scss';
import { CopyText, Heading } from '../../../../../../UiKit';
import { Timer } from '../.././../../../commons';
import { Footer } from '../../common';
import { getSuccessDetails } from '../../../ActionOptions/SuccessScreen';

export default class StatusView extends Component {
  getTextTemplate = () => {
    const { response } = this.props;
    if (!response) return null;

    const { texts } = response;

    return (
      texts &&
      texts.map((message, index) => {
        return (
          <React.Fragment key={index}>
            <p
              className='text'
              style={{
                fontWeight: message.type,
                color: message.color,
                textAlign: message.align,
                whiteSpace: 'pre-wrap',
              }}
            >
              {message.text}
            </p>
            {message.break && <br></br>}
          </React.Fragment>
        );
      })
    );
  };

  submitButton = (url) => {
    const { tryAgain } = this.props;
    tryAgain(url);
  };

  render() {
    const {
      response,
      imgWidth = '6vh',
      imgHeight = '8vh',
      everyMinuteHandler = () => {},
    } = this.props;

    if (!response) return null;

    const {
      title,
      image,
      autoresolve_timestamp,
      link,
      submit_button,
      color,
      copy_message_list,
    } = response || {};

    return (
      <React.Fragment>
        {title && (
          <div className='statusViewHeading'>
            <Heading title={title.text} />
          </div>
        )}

        <div className='statusView'>
          {image ? (
            <div className='img' style={{ width: imgWidth, height: imgHeight }}>
              <img src={image} alt='statusview' />
            </div>
          ) : null}

          {this.getTextTemplate()}

          {copy_message_list && (
            <div
              className={`tw-w-full tw-flex tw-flex-col'
            }`}
            >
              {getSuccessDetails([
                {
                  type: 'copy_message_list',
                  bg_color: copy_message_list.bg_color || '#e5f3f35c',
                  orientation: 'vertical',
                  children: copy_message_list.chat_messages || [],
                },
              ])}
            </div>
          )}

          {autoresolve_timestamp ? (
            <Timer
              timestamp={autoresolve_timestamp}
              everyMinuteHandler={everyMinuteHandler}
              type='bold'
            />
          ) : null}

          {link && (
            <div className='colorGreen'>
              <CopyText title={link} />
            </div>
          )}

          {submit_button ? (
            <Footer
              issueInfo={response}
              btnBgColor={color}
              sendFormData={this.submitButton.bind(this, submit_button.url)}
            />
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}
